import { collectionUrl } from '@/lib/collectionUrl';
import { canonicalPath, productUrl } from '@workspace/url-source';

export type MegaItem = {
  label: string;
  href: string;
  icon?: string;
  featured?: boolean;
};

export type MegaSection = {
  id: string;
  title: string;
  href?: string;           // optional "Pokaż" link in column header
  icon: string;
  items: MegaItem[];
};

export type MegaFeaturedProduct = {
  title: string;
  description: string;
  price: string;
  image: string;          // filename relative to BASE_URL (public folder)
  href: string;
  badge?: string;
};

/* ── KWIATY mega menu ─ 2 kolumny ─────────────────── */
export const KWIATY_SECTIONS: MegaSection[] = [
  {
    id: 'kwiaty',
    title: 'Kwiaty',
    href: collectionUrl('kwiaty'),
    icon: 'flower2',
    items: [
      { label: 'Róże', href: collectionUrl('Róże'), icon: 'flower2' }, { label: 'Lilie', href: collectionUrl('Lilie'), icon: 'flower2' }, { label: 'Gerbery', href: collectionUrl('Gerbery'), icon: 'flower' }, { label: 'Goździki', href: collectionUrl('Goździki'), icon: 'flower2' }, { label: 'Słoneczniki', href: collectionUrl('Słoneczniki'), icon: 'flower' }, { label: 'Alstroemerie', href: collectionUrl('Alstroemerie'), icon: 'flower2' }, { label: 'Eustomy', href: collectionUrl('Eustomy'), icon: 'flower' }, { label: 'Gipsówka', href: collectionUrl('Gipsówka'), icon: 'flower2' }, { label: 'Margaretki', href: collectionUrl('Margaretki'), icon: 'flower' }, { label: 'Piwonie', href: collectionUrl('piwonie'), icon: 'flower2' }, { label: 'Hortensje', href: collectionUrl('hortensje'), icon: 'flower' }, { label: 'Lewkonie', href: collectionUrl('lewkonie'), icon: 'flower2' }, { label: 'Frezje', href: collectionUrl('frezje'), icon: 'flower' }, { label: 'Jaskier', href: collectionUrl('jaskier'), icon: 'flower2' }, { label: 'Anturium', href: collectionUrl('anturium'), icon: 'flower' }, { label: 'Lwie paszcze', href: collectionUrl('lwiepaszcze'), icon: 'flower2' }, { label: 'Dalie', href: collectionUrl('dalie'), icon: 'flower' }, { label: 'Tulipany', href: collectionUrl('tulipany'), icon: 'flower' }, { label: 'Wszystkie kwiaty', href: collectionUrl('kwiaty'), icon: 'flower2' },
    ],
  },
  {
    id: 'inne',
    title: 'Inne',
    icon: 'sprout',
    items: [
      { label: 'Flower Box', href: collectionUrl('flower-box'), icon: 'gift' }, { label: 'Kosze kwiatowe', href: collectionUrl('kosze-kwiatowe'), icon: 'shopping-basket' }, { label: 'Kwiaty w torebce', href: collectionUrl('Kwiaty-w-torebce'), icon: 'shopping-basket' }, { label: 'Lasy w szkle', href: collectionUrl('Lasy-w-szkle'), icon: 'leaf' }, { label: 'Balony z helem', href: collectionUrl('Balony-z-helem'), icon: 'leaf' }, { label: 'Kwiaty doniczkowe', href: collectionUrl('Kwiaty-doniczkowe'), icon: 'leaf' }, { label: 'Wieczne róże', href: collectionUrl('Wieczne-róże'), icon: 'flower2' },
    ],
  },
];

/* ── BUKIETY column products (10 rotating) ──── */
export type BukietyProduct = {
  title: string;
  description: string;
  price: number;   // "od X zł"
  image: string;   // filename relative to BASE_URL
  href: string;
};

export const BUKIETY_PRODUCTS: BukietyProduct[] = [
  { title: 'Bukiet Pastelowy',  description: 'Delikatne pastele dobrane z myślą o urodzinach i imieninach. Miękkie barwy tworzą ciepłą, radosną kompozycję, która zachwyca od pierwszego spojrzenia.',         price: 139, image: 'bouquet-birthday.png',    href: productUrl('bukiet-pastelowy') },
  { title: 'Bukiet Klasyczny',  description: 'Ponadczasowa kompozycja ze świeżych, sezonowych kwiatów. Elegancka i prosta - sprawdzi się na każdą okazję i do każdego wnętrza.',                               price: 89,  image: 'bouquet-maly.png',         href: '/bukiet-klasyczny' },
  { title: 'Bukiet Różany',     description: 'Pełne, aksamitne róże w głębokiej czerwieni - klasyczny symbol miłości i elegancji. Gotowy do odbioru lub dostawy tego samego dnia.',                            price: 119, image: 'kreator-roze.jpg',         href: '/bukiet-rozany' },
  { title: 'Bukiet z Peonii',   description: 'Puszyste piwonie w delikatnych odcieniach różu i bieli. Luksusowa kompozycja idealna na ślub, rocznicę lub wyjątkowe podziękowanie.',                            price: 159, image: 'bouquet-sredni.png',       href: '/bukiet-z-peonii' },
  { title: 'Bukiet Biały',      description: 'Śnieżnobiała kompozycja łącząca czystość i prostotę. Idealna na chrzciny, komunię lub jako wyraz szczerego uczucia i szacunku.',                                  price: 99,  image: 'bouquet-birthday.png',     href: '/bukiet-bialy' },
  { title: 'Bukiet Słoneczny',  description: 'Energetyczne słoneczniki i żółte akcenty, które rozjaśniają każde pomieszczenie. Radosna kompozycja przynosząca uśmiech na twarzy obdarowanej osoby.',            price: 79,  image: 'kreator-sloneczniki.jpg',  href: '/bukiet-sloneczny' },
  { title: 'Bukiet Elegancki',  description: 'Wyrafinowana kompozycja dla tych, którzy cenią styl i klasę. Dobór kwiatów i kolorów podkreśla wyjątkowość każdej chwili i każdej osoby.',                       price: 179, image: 'bouquet-premium.png',      href: '/bukiet-elegancki' },
  { title: 'Bukiet Polny',      description: 'Gerbery, margaretki i sezonowe kwiaty łąkowe - radosny powiew natury zamknięty w bukiecie. Świeży i kolorowy, jak spacer po kwitnącej łące.',                   price: 109, image: 'kreator-gerbery.jpg',      href: '/bukiet-polny' },
  { title: 'Bukiet Premium',    description: 'Najpiękniejsze kwiaty sezonu zebrane w jednej wyjątkowej kompozycji. Starannie dobrane przez naszych florystów - gotowe na każdą wielką chwilę.',                 price: 149, image: 'bouquet-roses-red.png',    href: '/bukiet-premium' },
  { title: 'Bukiet Romantic',   description: 'Kolorowe tulipany i delikatne dodatki tworzą bukiet idealny do wyznania uczuć. Subtelny, ale wymowny - mówi więcej niż tysiąc słów.',                           price: 129, image: 'kreator-tulipany.jpg',     href: '/bukiet-romantic' },
].map(product => ({ ...product, href: productUrl(product.href) }));

export const KWIATY_FEATURED: MegaFeaturedProduct = {
  title: 'Nasze Bestsellery',
  description: 'Kompozycje, które podbiły serca naszych klientów - sprawdzone wybory na każdą okazję.',
  price: 'od 79 zł',
  image: 'bouquet-roses-red.png',
  href: collectionUrl('bestsellery'),
  badge: 'Bestseller',
};

/* ── OKAZJE mega menu ─ 2 kolumny ────────────────── */
export const OKAZJE_SECTIONS: MegaSection[] = [
  {
    id: 'okazje',
    title: 'Na jaką okazję',
    icon: 'gift',
    items: [
      { label: 'Urodziny', href: collectionUrl('Urodziny'), icon: 'cake-slice' }, { label: 'Imieniny', href: collectionUrl('Imieniny'), icon: 'party-popper' }, { label: 'Rocznica', href: collectionUrl('Rocznica'), icon: 'heart' }, { label: 'Przeprosiny', href: collectionUrl('Przeprosiny'), icon: 'flower' }, { label: 'Gratulacje', href: collectionUrl('Gratulacje'), icon: 'sparkles' }, { label: 'Podziękowania', href: collectionUrl('Podziekowania'), icon: 'heart-handshake' }, { label: 'Niespodzianka', href: collectionUrl('Niespodzianka'), icon: 'gift' }, { label: 'Komunia', href: collectionUrl('Komunia'), icon: 'cross' }, { label: 'Obrona', href: collectionUrl('Obrona'), icon: 'sparkles' }, { label: 'Zaręczyny', href: collectionUrl('Zareczynny'), icon: 'heart-handshake' },
    ],
  },
  {
    id: 'dla-kogo',
    title: 'Dla kogo',
    icon: 'user-round',
    items: [
      { label: 'Dla Pary Młodej', href: collectionUrl('Dla-pary-mlodej'), icon: 'heart' }, { label: 'Dla mamy', href: collectionUrl('Dla-mamy'), icon: 'user-round' }, { label: 'Dla żony', href: collectionUrl('Dla-zony'), icon: 'heart' }, { label: 'Dla dziewczyny', href: collectionUrl('Dla-dziewczyny'), icon: 'heart-handshake' }, { label: 'Dla babci', href: collectionUrl('Dla-babci'), icon: 'user-round' }, { label: 'Dla mężczyzny', href: collectionUrl('Dla-mezczyzny'), icon: 'user' }, { label: 'Dla przyjaciela', href: collectionUrl('Dla-przyjaciela'), icon: 'user-round' },
    ],
  },
  {
    id: 'swieta',
    title: 'Nadchodzące święta',
    icon: 'calendar-days',
    items: [
      { label: 'Dzień Babci i Dziadka', href: collectionUrl('Dzien-babci-i-dziadka'), icon: 'user-round' }, { label: 'Walentynki', href: collectionUrl('Walentynki'), icon: 'heart' }, { label: 'Dzień Kobiet', href: collectionUrl('Dzien-kobiet'), icon: 'flower2' }, { label: 'Wielkanoc', href: collectionUrl('Wielkanoc'), icon: 'flower' }, { label: 'Dzień Matki', href: collectionUrl('Dzien-matki'), icon: 'heart' }, { label: 'Dzień Dziecka', href: collectionUrl('Dzien-dziecka'), icon: 'baby' }, { label: 'Dzień Ojca', href: collectionUrl('Dzien-ojca'), icon: 'user' }, { label: 'Wszystkich Świętych', href: collectionUrl('Wszystkich-swietych'), icon: 'cross' }, { label: 'Boże Narodzenie', href: collectionUrl('Boze-narodzenie'), icon: 'star' },
    ],
  },
];

export const OKAZJE_FEATURED: MegaFeaturedProduct = {
  title: 'Bukiet Urodzinowy',
  description: 'Klasyczna kompozycja różana - idealna niespodzianka na każdą wyjątkową okazję.',
  price: 'od 99 zł',
  image: 'bouquet-birthday.png',
  href: collectionUrl('polecane'),
  badge: 'Polecamy',
};

/**
 * Derives breadcrumb parent from menu structure — single source of truth.
 * Any item listed in KWIATY_SECTIONS → parent "Kwiaty".
 * Any item listed in OKAZJE_SECTIONS  → parent "Okazje".
 * Returns null for top-level pages (no parent needed).
 */
export function findBreadcrumbParent(handle: string): { label: string; href?: string } | null {
  const href = collectionUrl(handle);
  if (href === collectionUrl('kwiaty') || href === collectionUrl('okazje')) return null;

  if (href.startsWith('/dla-kogo/')) {
    return { label: 'Dla kogo', href: '/dla-kogo/' };
  }

  for (const section of KWIATY_SECTIONS) {
    if (section.items.some(item => item.href === href)) {
      return { label: 'Kwiaty', href: collectionUrl('kwiaty') };
    }
  }

  for (const section of OKAZJE_SECTIONS) {
    if (section.items.some(item => item.href === href)) {
      return { label: 'Okazje', href: collectionUrl('okazje') };
    }
  }

  return null;
}

/* ── KREATOR mega menu ──────────────────────── */
export type KreatorItem = {
  label: string;
  sublabel: string;
  href: string;
  image: string;        // filename relative to BASE_URL (public folder)
  badge?: string;
  description?: string; // shown in product-style card
  price?: number;       // "od X zł"
};

export const KREATOR_ITEMS: KreatorItem[] = [
  {
    label: 'Kreator Róż',
    sublabel: 'Klasyka w każdym odcieniu',
    href: canonicalPath('/kreator/roze'),
    image: 'kreator-roze.jpg',
    badge: 'Bestseller',
    description: 'Dobierz liczbę, kolor i styl. Od klasycznej czerwieni po delikatne pastele.',
    price: 55,
  },
  {
    label: 'Kreator Tulipanów',
    sublabel: 'Wiosna zamknięta w bukiecie',
    href: canonicalPath('/kreator/tulipany'),
    image: 'kreator-tulipany.jpg',
    description: 'Wiosenne tulipany w dowolnym kolorze i liczbie - radosna kompozycja na każdą okazję.',
    price: 30,
  },
  {
    label: 'Kreator Słoneczników',
    sublabel: 'Radość i energia w kwiatach',
    href: canonicalPath('/kreator/sloneczniki'),
    image: 'kreator-sloneczniki.jpg',
    description: 'Słoneczne kompozycje pełne energii - idealne na urodziny i podziękowania.',
    price: 27,
  },
  {
    label: 'Kreator Gerber',
    sublabel: 'Kolory, które mówią same za siebie',
    href: canonicalPath('/kreator/gerbery'),
    image: 'kreator-gerbery.jpg',
    description: 'Kolorowe gerbery na każdą okazję - wybierz swoje ulubione odcienie.',
    price: 35,
  },
  {
    label: 'Kreator Lilii',
    sublabel: 'Elegancja i wyjątkowy aromat',
    href: canonicalPath('/kreator/lilie'),
    image: 'kreator-roze.jpg',
    description: 'Dobierz liczbę i kolor lilii do tworzonego bukietu.',
    price: 36,
  },
  {
    label: 'Kreator Eustom',
    sublabel: 'Delikatne kwiaty na wyjątkowe chwile',
    href: canonicalPath('/kreator/eustomy'),
    image: 'kreator-tulipany.jpg',
    description: 'Stwórz subtelną kompozycję eustom w wybranym kolorze.',
    price: 50,
  },
];

/* ── POGRZEB mega menu ──────────────────────── */
export const POGRZEB_ITEMS: KreatorItem[] = [
  {
    label: 'Bukiety pogrzebowe',
    sublabel: 'Eleganckie kompozycje na pożegnanie',
    href: collectionUrl('bukiety-pogrzebowe'),
    image: 'bukiet-pogrzebowy.png',
  },
  {
    label: 'Wieńce pogrzebowe',
    sublabel: 'Tradycja i szacunek w kwiatach',
    href: collectionUrl('wience-pogrzebowe'),
    image: 'wieniec-pogrzebowy.png',
  },
  {
    label: 'Wiązanki pogrzebowe',
    sublabel: 'Delikatne kompozycje z wybranych kwiatów',
    href: collectionUrl('wiazanki-pogrzebowe'),
    image: 'wiazanka-pogrzebowa.png',
  },
  {
    label: 'Sztuczne kompozycje',
    sublabel: 'Trwałe i nieprzemijające',
    href: collectionUrl('sztuczne-kompozycje'),
    image: 'sztuczna-kompozycja.png',
  },
];

export const POGRZEB_SECTIONS: MegaSection[] = [
  {
    id: 'pogrzeb',
    title: 'Kompozycje pogrzebowe',
    href: collectionUrl('kompozycje-pogrzebowe'),
    icon: 'flower',
    items: [
      { label: 'Bukiety pogrzebowe', href: collectionUrl('bukiety-pogrzebowe'), icon: 'flower2' }, { label: 'Wieńce pogrzebowe', href: collectionUrl('wience-pogrzebowe'), icon: 'flower' }, { label: 'Wiązanki pogrzebowe', href: collectionUrl('wiazanki-pogrzebowe'), icon: 'flower2' }, { label: 'Sztuczne kompozycje', href: collectionUrl('sztuczne-kompozycje'), icon: 'flower' },
    ],
  },
];
